<script setup lang="ts">
import Button from "./ButtonAction.vue";
import IconStar from "@/assets/icons-svg/icon-star.svg";
import { computed, getCurrentInstance, onMounted, ref, watch } from "vue";
import { DxLoadIndicator } from 'devextreme-vue'
import traducao from "@/localization/vistra.paineis.json";
import Ping from 'ping.js'
import { useStore } from "vuex";

const app = getCurrentInstance()
const { $http, $vistra } = app?.appContext.config.globalProperties

type Props = {
  title: string;
  preview: string;
  favorite: boolean;
  painel: object;
  usuario: object;
};

type EmitHandles = {
  (e: 'oninfo'): void;
  (e: 'onmore'): void;
  (e: 'onfavorite'): Promise<void>;
  (e: 'addNovoPainel', painel:any): void;
  (e: 'excluir', painel:any): void;
};


const store = useStore();
const isOnline = computed(() => store.getters.isOnline)
const imagemCarregada = computed(() => props.painel.imagem || !props.painel.temImagem)
const usarIconeComoImagem = ref(false);
const submenuVisivel = ref(false);
const botaoMoreAction = ref();
const props = defineProps<Props>();
const emit = defineEmits<EmitHandles>();

const moreAction = () => {
  submenuVisivel.value = !submenuVisivel.value;
}

const visualizar = async (e) => {
  if (e.defaultPrevented)
      return;
  if (props.painel.vistra4) {
      let acesso = await $http.get("/Usuario/GetAcessoPortal")
      if (acesso.data.msgErro) {
          $vistra.showMessage(acesso.data.msgErro)
          return
      }

      const isValidURL = (url) => {
          return new Promise(resolve => {
              if (!url)
                  return resolve(false)
              const p = new Ping()
              p.ping(url)
              .then(data => {
                  resolve(true);
              })
              .catch(data => {
                  resolve(false)
              })
          })
      }
      try {
          let urlAplicacao = acesso.data.urlAplicacao                
          if (!(await isValidURL(acesso.data.urlAplicacao)) && await isValidURL(acesso.data.urlAplicacao2))
              urlAplicacao = acesso.data.urlAplicacao2

          let params = {
              vistra_user_login: props.usuario.id, 
              vistra_user_password: acesso.data.senha, 
              vistra_url: `${urlAplicacao}/Painel/${props.painel.id}/painel`,
              vistra_crm: true
          }
          var form = document.createElement("form");
          form.setAttribute("method", "post");
          form.setAttribute("action", urlAplicacao + "/Login.aspx");
          form.target = "_blank";
          for(var key in params) {
              if(params.hasOwnProperty(key)) {
                  var hiddenField = document.createElement("input");
                  hiddenField.setAttribute("type", "hidden");
                  hiddenField.setAttribute("name", key);
                  hiddenField.setAttribute("value", params[key]);            
                  form.appendChild(hiddenField);
              }
          }
          document.body.appendChild(form);
          form.submit();
      } catch {

      }
  }
  else {
      let temPermissao = await $vistra.temPermissao("/PerfilUsuario/GetPermissaoPainelPro/" + props.painel.id, "visualizar");
      if (temPermissao) {
          $vistra.goTo(`${window.location.origin}/painel/${props.painel.id}`, true);
      } else {
          $vistra.showMessage($vistra.globalize("msg-sem-permissao-visualizar"), "warning");
      }
  }
}

const clickPainel = (e) => {
  submenuVisivel.value = false;
  visualizar(e);
}

const editar = async (e) => {
    e.preventDefault();
    let temPermissao = await $vistra.temPermissao("/PerfilUsuario/GetPermissaoPainelDev/" + props.painel.id, "alterar");
    if (temPermissao) {
        $vistra.goTo(`${window.location.origin}/dev.painel/${props.painel.id}`, true);
    } else {
        $vistra.showMessage($vistra.globalize("msg-sem-permissao-alterar"), "warning");
    }
}
const clonar = async (e) => {
    e.preventDefault();

    $vistra.showMessageConfirmacao(
        //mensagem
        $vistra.globalize('confirma-clonagem-painel'),
        //titulo
        props.painel.nome,
        //confirmar
        async () => {
          $http.post("/Painel/ClonarPainel", { id: props.painel.id }).then(response => {
              let novoPainel = JSON.parse(JSON.stringify(props.painel));
              novoPainel.id = response.data.id;
              novoPainel.idUnico = response.data.idUnico;
              novoPainel.nome = response.data.nome;

              emit('addNovoPainel', novoPainel);

              $vistra.showMessageConfirmacao(
              //mensagem
              $vistra.globalize('confirma-redirecionar-painel-clonado'),
              //titulo
              $vistra.globalize('sucesso'),
              //confirmar
              async () => {
                  $vistra.goTo("dev.painel/" + novoPainel.id);
              },
              //cancelar
              () => { }
              )
          });
      },
    //cancelar
    () => { }
    );
}

const excluir = async (e) => {
    e.preventDefault();
    let temPermissao = await $vistra.temPermissao("/PerfilUsuario/GetPermissaoPainelDev/" + props.painel.id, "excluir");
    if (temPermissao) {
        $vistra.showMessageConfirmacao($vistra.globalize("msg-deseja-realmente-excluir"), $vistra.globalize("menu-paineis"), () => {
          emit("excluir", props.painel);                        
        })    
    } else {
        $vistra.showMessage($vistra.globalize("msg-sem-permissao-excluir"), "warning");
    }
}
let tiposPerfil = $vistra.Tipos.Perfil;
let itensSubMenu = [
  {icon: 'fal fa-pen', nome: $vistra.globalize('btn-editar'), action: editar, visible: props.usuario.perfil === tiposPerfil.Dev},
  {icon: 'fal fa-clone', nome: $vistra.globalize('clonar-painel'), action: clonar, visible: props.usuario.perfil === tiposPerfil.Dev},
  {icon: 'fal fa-trash-alt', nome: $vistra.globalize('btn-excluir'), action: excluir, visible: props.usuario.perfil === tiposPerfil.Dev},
]

const resetaVisiblidadeMenu = (e) => {
  if(e.target?.offsetParent?.outerHTML !== botaoMoreAction.value?.$el?.outerHTML) {
    submenuVisivel.value = false;
  }
}

const imagemTema  = computed(() => {
  return store.getters.tema == 'tema-dark' ? 'imagemEscura' : 'imagem'
})

$vistra.carregaTraducao([traducao])
</script>
<template>
  <div class="card-panel group" style="position: relative">
    <!-- <div v-if="!painel.vistra4" ref="subMenu" v-show="submenuVisivel" id="submenu-painel" class="opacity-0 group-hover:opacity-100">
      <ul>
        <template v-for="item in itensSubMenu">
          <li v-if="item.visible" @click="item.action">
            <i :class="item.icon + ' mr-3'"></i>{{item.nome}}
          </li>
        </template>
      </ul>
    </div> -->
    <div class="botoes-card" @click="resetaVisiblidadeMenu">
      <!-- <Button
        v-if="(!painel.vistra4 && itensSubMenu.some( i => i.visible))"
        ref="botaoMoreAction"
        class="top-5 opacity-0 right-[5.5rem] group-hover:top-2 group-hover:opacity-100"
        @click="moreAction"
      >
        <i class="dx-icon-overflow text-lg"></i>
      </Button> -->

      <Button
        ref="botaoInfo"
        class="top-5 opacity-0 right-12 group-hover:top-2 group-hover:opacity-100"
        :disabled="!painel.descricao"
        @click="$emit('oninfo')"
      >
        <i class="dx-icon-info text-md" :class="!painel.descricao ? 'text-gray-500' : ''"></i>
      </Button>

      <Button
        v-if="isOnline"
        ref="botaoFavorito"
        class="top-4 opacity-0 right-2 group-hover:top-2 group-hover:opacity-100 hover:!text-yellow"
        :class="
          favorite
            ? 'fill-yellow !text-yellow !top-2 !opacity-100'
            : 'fill-transparent'
        "
        @click="$emit('onfavorite', painel.id)"
      >
        <IconStar ref="iconeFavorito"/>
      </Button>
    </div>
    <div
      class="rounded h-full flex flex-col border border-solid border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700"
      @click="clickPainel"
    >
      <div class="px-1 pt-1 relative container-imagem-card-painel">
        <dx-load-indicator v-if="!imagemCarregada" style="position: absolute"></dx-load-indicator>
        <img v-if="!imagemCarregada" class="invisible w-full rounded-md h-28 object-cover" />
        <img v-else-if="painel[imagemTema]" :src="painel[imagemTema]" alt="" class="w-full rounded-md h-28 object-cover" />
        <template v-else>
          <i class="fad fa-chart-tree-map h-28" style="font-size: 7.5rem;"></i>
        </template>
      </div>

      <h3 class="py-4 px-3 text-gray-900 dark:text-white">{{ title }}</h3>
    </div>
  </div>
</template>

<style lang="scss">
.card-panel {
  cursor: pointer;
  .botoes-card {
    z-index: 1;
    position: absolute;
    height: 50px;
    right: 0;
  }
  h3 {
    overflow: hidden !important;
    text-overflow: ellipsis;
  }

  i.fad.fa-image {
    font-size: 112px;
    text-align: center;
    width: 100%;
  }
  #submenu-painel {
    @apply dark:bg-gray-800 p-2 bg-gray-200 shadow-md;
    position: absolute;
    width: max-content;
    z-index: 1;
    left: 66px;
    top: 38px;
    ul li {
      transition: .2s;
      @apply hover:text-primary-500 p-1;
      display: flex;
      align-items: center;
      // &hover {
      //   @apply text-primary;
      // }
    }
  }
  .container-imagem-card-painel {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

</style>
